import { Box } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemedLoadingAnimation } from './themed';

export const AdminLoadingFallback = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
    }}
  >
    <AnimatePresence>
      <motion.div
        key="admin-loading-fallback"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2, delay: 0.1 }}
      >
        <ThemedLoadingAnimation message="Loading admin panel..." />
      </motion.div>
    </AnimatePresence>
  </Box>
);
